import { getLocaleDefinition, type LocaleCode } from "@/i18n/locales";

export function formatCurrency(value: number, locale: LocaleCode): string {
    return new Intl.NumberFormat(getLocaleDefinition(locale).intlLocale, {
        style: "currency",
        currency: "ILS",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}

export function formatStatus(value: string): string {
    return value
        .toLocaleLowerCase()
        .replaceAll("_", " ")
        .replace(/\b\p{L}/gu, character => character.toLocaleUpperCase());
}

type DeliverySlot = {
    deliverySlotDate?: string;
    deliverySlotTimeStart?: string;
    deliverySlotTimeEnd?: string;
};

export function formatDeliverySlot(slot: DeliverySlot, locale: LocaleCode): string | null {
    if (!slot.deliverySlotDate) return null;
    const date = /^\d{4}-\d{2}-\d{2}$/.test(slot.deliverySlotDate)
        ? new Date(`${slot.deliverySlotDate}T12:00:00`)
        : new Date(slot.deliverySlotDate);
    if (Number.isNaN(date.getTime())) return null;

    const dateLabel = new Intl.DateTimeFormat(getLocaleDefinition(locale).intlLocale, {
        dateStyle: "medium"
    }).format(date);
    const startTime = slot.deliverySlotTimeStart?.slice(0, 5);
    const endTime = slot.deliverySlotTimeEnd?.slice(0, 5);
    const timeLabel = startTime && endTime ? `${startTime}–${endTime}` : startTime ?? endTime;

    return timeLabel ? `${dateLabel} · ${timeLabel}` : dateLabel;
}
